// extracted by mini-css-extract-plugin
module.exports = {"PriceLabelFrames":"idt-pricelabelframes_pricelabelframes__snhqo"};